import { useState } from 'react';
import { Col, Card, CardHeader, CardBody, Input } from 'reactstrap';
import { Collapse } from 'reactstrap';
import { Filter } from 'Constant';
import { H5, Btn } from 'AbstractElements';
import PriceCheck from '../Common/CheckBox/PriceCheck';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPopupNotifications } from './PopupNotificationUtils';
import { setFilters } from 'Features/Learning/PopupNotification/popupNotificationSlice';

const PopNotificationFind = () => {
  const [isFilter, setIsFilter] = useState(true);
  const dispatch = useDispatch()
  const filters = useSelector(state => state.PopupNotification.filters)

  const handleClickSearch = (e) => {
    e.preventDefault()
    const newFilters = {
      ...filters,
      'page': 1,
    };
    dispatch(setFilters(newFilters));
    fetchPopupNotifications(dispatch, newFilters);
  }

  const handleResetFilter = () => {
    const newFilters = {
      ...filters,
      'filter[target_page]': '',
      'filter[is_show]': '',
      'filter[id]': '',
      'sort': '',
      'page': 1,
    };

    dispatch(setFilters(newFilters));
    fetchPopupNotifications(dispatch, newFilters);
  }

  return (
    <Col xl="12">
      <Card>
        <CardHeader>
          <H5 attrH5={{ className: 'mb-0' }}>
            <Btn attrBtn={{ className: 'btn btn-link ps-0', onClick: () => setIsFilter(!isFilter), color: 'transperant', datastoggle: 'collapse', databstarget: '#collapseicon', ariaexpanded: 'true', ariacontrols: 'collapseicon' }} >{'Temukan Popup Notification'}</Btn>
          </H5>
        </CardHeader>
        <Collapse isOpen={isFilter}>
          <div className="collapse show" id="collapseicon" aria-labelledby="collapseicon" data-parent="#accordion">
            <CardBody className="filter-cards-view animate-chk">
              <div className="job-filter mb-3">
                <label className="col-form-label" style={{ fontWeight: 'bold' }}>Terlihat:</label>
                <Input
                  type="select"
                  className="form-control"
                  value={filters?.['filter[is_show]'] || ''}
                  onChange={(e) => {
                    dispatch(setFilters({
                      ...filters,
                      'filter[is_show]': e.target.value,
                    }));
                  }}
                >
                  <option value="">Semua</option>
                  <option value="1">Ya</option>
                  <option value="0">Tidak</option>
                </Input>
              </div>

              <div className="job-filter mb-3">
                <label className="col-form-label" style={{ fontWeight: 'bold' }}>Ditampilkan di:</label>
                <Input
                  type="select"
                  className="form-control"
                  value={filters?.['filter[target_page]'] || ''}
                  onChange={(e) => {
                    dispatch(setFilters({
                      ...filters,
                      'filter[target_page]': e.target.value,
                    }));
                  }}
                >
                  <option value="">Semua</option>
                  <option value="home">Home</option>
                  <option value="overview">Overview</option>
                  <option value="both">Keduanya (Home + Overview)</option>
                </Input>
              </div>
              <PriceCheck
                filters={filters}
                onSortChange={(e) => {
                  dispatch(setFilters({
                    ...filters,
                    sort: e.target.value,
                  }));
                }}
                idPrefix="popup-sort"
              />
              <div className="row">
                <div className="col-md-6">
                  <Btn attrBtn={{ color: 'primary text-center p-1', onClick: handleClickSearch }}>{Filter}</Btn>
                </div>
                <div className="col-md-6">
                  <Btn attrBtn={{ color: 'warning text-center p-1', onClick: handleResetFilter }}>{'Reset'}</Btn>
                </div>
              </div>
            </CardBody>
          </div>
        </Collapse>
      </Card>
    </Col>
  );
};

export default PopNotificationFind;